import { getAppEnv } from "../parcel_macros" with { type: "macro" };
import { loadBetaAppEnv } from "./beta";
import { loadLudaAppEnv } from "./luda";
import { loadPaturaAppEnv } from "./patura";

export function initAppEnv() {
	loadCommonAssets();
	loadAppEnv();
	appendTitle();
	appendFavicon();
}

function loadAppEnv() {
	switch (getAppEnv()) {
		case "beta":
			loadBetaAppEnv(assets, config);
			break;
		case "luda":
			loadLudaAppEnv(assets, config);
			break;
		case "patura":
			loadPaturaAppEnv(assets, config);
			break;
		default:
			throw "must specify app env";
	}
}

function appendTitle() {
	const title = document.createElement("title");
	title.textContent = config.appId;
	document.head.append(title);
}

function appendFavicon() {
	const favicon = document.createElement("link");
	favicon.rel = "icon";
	favicon.type = "image/png";
	favicon.href = assets["favicon-32x32.png"];
	document.head.append(favicon);
}

function loadCommonAssets() {
	assets["farmcam-sim.svg"] = new URL("../assets/farmcam-sim.svg", import.meta.url).href;
	assets["fencealarm.svg"] = new URL("../assets/fencealarm.svg", import.meta.url).href;
	assets["fencealarm2.svg"] = new URL("../assets/fencealarm2.svg", import.meta.url).href;
	assets["smartplug.svg"] = new URL("../assets/smartplug.svg", import.meta.url).href;
	assets["smartplug2.svg"] = new URL("../assets/smartplug2.svg", import.meta.url).href;
}

/**
 * @type {Record<string,string>}
 */
export const assets = {};

/**
 * @typedef {{
 *      apiBaseUrl: string
 * 		apiHost: string
 *      appId: string
 *      baseUrl: string
 *      brand: string
 *      navbarTheme: string
 * 		sp2gwHost: string
 * 		sp2gwSelfSignedHost: string
 *      stripeBaseUrl: string
 *      supportedDevices: DeviceType[]
 * }} Config
 */

/**
 * @type {Config}
 */
export const config = {
	apiBaseUrl: "",
	apiHost: "",
	appId: "",
	baseUrl: "",
	brand: "",
	navbarTheme: "",
	sp2gwHost: "",
	sp2gwSelfSignedHost: "",
	stripeBaseUrl: "",
	supportedDevices: [],
};
